import React from "react";

function EmailManager() {
  return (
    <div className="email_manager">
      <div className="tag_btn wow fadeInUp">Product Features</div>

      <div className="t f_24 wow fadeInUp">
        Your Personal CareerPrep Assistant
      </div>

      <div className="des wow fadeInUp">
        Track better, learn faster, and stay ahead — all in one place.
      </div>

      {/* <div className="video wow fadeInUp">
        <video
          id="video"
          preload="metadata"
          loop
          autoPlay
          muted
          playsInline
          webkit-playsinline="webkit-playsinline"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          data-object-fit="cover"
          x5-video-orientation="portrait"
          data-autoplay=""
        >
          <source src="https://qiniu.mfdemo.cn/sanyuanyuan/2024/10/15/670e2a1937adb.mp4" />
        </video>
      </div> */}

      <div className="wrap">
        <div className="item wow fadeInUp">
          <div className="box">
            <div className="b">
              <p>Adaptive Challenges</p>
              <div className="dot"></div>
            </div>
            <div className="b">
              <p>Referral Tracker</p>
              <div className="dot"></div>
            </div>
            <div className="b">
              <p>Custom Development Plans</p>
              <div className="dot"></div>
            </div>
          </div>
          <p className="pt f_32">Upcoming Features</p>
          <div className="des">
            Instantly view your application status—applied, interviewed, or
            rejected.
          </div>
        </div>

        <div
          className="item nopadding wow fadeInUp"
          style={{ animationDelay: "100ms" }}
        >
          <div className="line_box">
            <div className="l_box"></div>
            <div className="c_box">
              <div className="line1">
                <img src="./images/line1.svg" alt="" />
                <img src="./images/line1_bg.png" alt="" />
              </div>
              <div className="line1">
                <img src="./images/line2.svg" alt="" />
                <img src="./images/line2_bg.png" alt="" />
              </div>
              <div className="line1">
                <img src="./images/line3.svg" alt="" />
                <img src="./images/line3_bg.png" alt="" />
              </div>
            </div>
            <div className="r_box">
              <div className="rb">
                <p>Overall Performance Assessment</p>
              </div>
              <div className="rb">
                <p>Improved Candidate Response</p>
              </div>
              <div className="rb">
                <p>Case Component Analysis</p>
              </div>
            </div>
          </div>
          <div className="text">
            <p className="pt f_32">Decoded Performance</p>
            <div className="des">
              Keep your CVs and submissions organized in one place.
            </div>
          </div>
        </div>

        <div className="item wow fadeInUp" style={{ animationDelay: "200ms" }}>
          <div className="table_box">
            <div className="bs">
              <div className="b">
                <p>S</p>
                <p>18</p>
              </div>
              <div className="b">
                <p>M</p>
                <p>19</p>
              </div>
              <div className="bg1"></div>
            </div>

            <div className="b">
              <p>T</p>
              <p>20</p>
            </div>
            <div className="b">
              <p>W</p>
              <p className="active">
                <span>21</span>
              </p>
              <div className="bg2"></div>
            </div>
            <div className="b">
              <p>T</p>
              <p>22</p>
            </div>
            <div className="b">
              <p>F</p>
              <p>23</p>
            </div>
            <div className="b">
              <p>S</p>
              <p>24</p>
              <div className="bg3"></div>
            </div>
          </div>

          <p className="pt f_32">Actionable Reports</p>
          <div className="des">
            Get daily / weekly insights to fine-tune your strategy.
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailManager;
